export default "__VITE_ASSET__D0e_O61G__"